(function () {
  'use strict';

  // Gives each testimonial video its own always-visible pause/play button,
  // since relying on YouTube's own in-player controls (small, hover-to-reveal)
  // isn't discoverable enough on touch devices. Keeps the existing
  // "starting one pauses the others" behavior in sync with these buttons.
  document.querySelectorAll('.rob-lp-testimonials__slider').forEach(function (slider) {
    var entries = [];

    function postCommand(media, func) {
      var iframe = media.querySelector('iframe.js-youtube');
      if (!iframe || !iframe.contentWindow) return;
      iframe.contentWindow.postMessage('{"event":"command","func":"' + func + '","args":""}', '*');
    }

    function setPaused(entry, paused) {
      entry.toggle.classList.toggle('is-paused', paused);
      entry.toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    function pauseOtherEntries(entry) {
      entries.forEach(function (other) {
        if (other === entry) return;
        if (!other.toggle.classList.contains('is-paused')) {
          postCommand(other.media, 'pauseVideo');
          setPaused(other, true);
        }
      });
    }

    slider.querySelectorAll('.rob-lp-testimonials__item').forEach(function (item) {
      var media = item.querySelector('deferred-media');
      var poster = item.querySelector('.deferred-media__poster');
      var toggle = item.querySelector('[data-rob-lp-video-toggle]');
      if (!media || !toggle) return;

      var entry = { media: media, toggle: toggle };
      entries.push(entry);

      if (poster) {
        poster.addEventListener('click', function () {
          // The video behind this poster is about to autoplay.
          pauseOtherEntries(entry);
          setPaused(entry, false);
        });
      }

      toggle.addEventListener('click', function () {
        var isPaused = toggle.classList.contains('is-paused');
        if (isPaused) {
          pauseOtherEntries(entry);
          postCommand(media, 'playVideo');
          setPaused(entry, false);
        } else {
          postCommand(media, 'pauseVideo');
          setPaused(entry, true);
        }
      });
    });
  });
})();
